import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { EventCategoryList } from "./EventCategoryList";

export const EventCategoryPage: FC = () => {
	return (
		<Routes>
			<Route index element={<EventCategoryList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
